import SampulIdentitasK13 from '../../../../views/Kurikulum/Raport/Cetak/SampulIdentitasK13.view.js';
import { connect } from 'react-redux';
import { getStudent } from '../../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch){ 
    return{
        handleGetStudent: () => dispatch(getStudent()),
    };
}
export default connect(null, mapDispatchToProps) (SampulIdentitasK13);
